import React, { memo, useContext, useEffect, useCallback, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactECharts from 'echarts-for-react';
import AppContext from 'context/Context';
import IconAlert from 'components/common/IconAlert';
import { defaultChartOptions } from 'services/glass-management/glassManagement';

const SLAChart = ({ loading, options, onClick = null, height = '330px' }) => {
    const { config: { isDark } } = useContext(AppContext);

    const onClickRef = useRef(onClick);
    useEffect(() => onClickRef.current = onClick, [onClick]);
    const handleChartClick = useCallback((e) => onClickRef.current?.(e), []);

    const _options = useMemo(() => { return { ...options, darkMode: isDark } }, [options, isDark]);
    return (
        (!loading && (!_options?.series[0]?.data?.length > 0 ||
            _options?.series?.data?.every(x => x.every(y => y.value === 0)))) ?
            (
                <div className='h-100 d-flex justify-content-center align-items-center align-middle'>
                    <IconAlert variant='info' className='mb-5 align-middle'><p className='h-100 align-middle p-0 m-0'>No Data to display!</p></IconAlert>
                </div >
            ) :
            (<ReactECharts
                option={_options || defaultChartOptions}
                style={{ height, width: '100%' }}
                showLoading={loading}
                onEvents={{
                    'click': handleChartClick
                }} />)
    );
}

SLAChart.propTypes = {
    loading: PropTypes.bool,
    options: PropTypes.object,
    height: PropTypes.string,
    onClick: PropTypes.func
};
export default memo(SLAChart);